import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { BaseFieldComponent } from '../base-field.component';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'ziq-boolean-value-field',
    templateUrl: './boolean-value-field.component.html',
    styleUrls: ['./boolean-value-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush

})
export class BooleanValueFieldComponent extends BaseFieldComponent {
    @HostBinding('class')
    readonly hostClass = 'ziq-boolean-value-field';

    get modelCurrentState() {
        return _.get(this, 'model.value.currentState');
    }

    get isDisabled() {
        return (this.fieldSettings ? this.fieldSettings.isDisabled(this.modelCurrentState) : false) || this.readOnly;
    }

    get property(): string {
        return _.get(this, 'fieldSettings.name') as string;
    }
}
